module.exports = __webpack_public_path__ + "static/media/samalmotors.19865ebd.png";